import _extends from '../../../node_modules/@babel/runtime/helpers/extends.js';
import _defineProperty from '../../../node_modules/@babel/runtime/helpers/defineProperty.js';
import _slicedToArray from '../../../node_modules/@babel/runtime/helpers/slicedToArray.js';
import _objectWithoutProperties from '../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js';
import { useState } from 'react';
import 'prop-types';
import { jsx } from '@emotion/core';
import { FieldControlContext } from './FieldControlContext.js';
import getPreferredValue from '../../utils/getPreferredValue.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var FieldControl = function FieldControl(_ref) {
  var status = _ref.status,
      theme = _ref.theme,
      children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, ["status", "theme", "children"]);

  var _useState = useState('default'),
      _useState2 = _slicedToArray(_useState, 2),
      defaultStatus = _useState2[0],
      setDefaultStatus = _useState2[1]; // Handles the touch of the input by setting valid flag in state accordingly


  var handleFieldTouch = function handleFieldTouch(value, required) {
    //  Set default behavior on state by setting status='error'
    // if input is required and empty when touched
    setDefaultStatus(value.length === 0 && required ? 'error' : 'default');
  }; // Use valid from props if available, otherwise use from state


  var contextState = {
    handleFieldTouch: handleFieldTouch,
    contextStatus: getPreferredValue(status, defaultStatus)
  };
  return jsx(FieldControlContext.Provider, {
    value: contextState
  }, jsx("div", _extends({
    css: _objectSpread({}, theme)
  }, otherProps), children));
};

FieldControl.defaultProps = {
  status: undefined,
  theme: undefined,
  children: null
};

export default FieldControl;
